import { LinkIcon, PhoneIcon } from 'lucide-react';

import { cn } from '@src/design-system/helpers';
import { buttonVariants } from '@src/design-system/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { MailIcon } from '@shared/assets/icons/shared/mail-icon';
import { copy } from '@shared/utils/helpers/copy';
import type { FC } from 'react';
import { WhatsappIcon } from '@shared/assets/icons/shared/whatsapp-icon';
import { Link } from 'react-router-dom';
import type { TMember } from '@shared/types/member';

const generateIconBtns = (user: TMember['user']) => {
  return [
    {
      icon: <MailIcon />,
      dropdownItems: [
        { label: user.email },
        {
          label: 'Copy Email',
          icon: <LinkIcon className='text-secondary-1000' />,
          onClick: () => copy(user.email),
        },
      ],
    },
    {
      icon: <PhoneIcon className='fill-[#00d95f] text-[#00d95f]' />,
      dropdownItems: [
        { label: user.phone_number },
        {
          label: 'Copy Number',
          icon: <LinkIcon className='text-secondary-1000' />,
          onClick: () => copy(user.phone_number),
        },
      ],
    },
  ];
};
export const UserContactInfo: FC<{ member: TMember }> = ({ member }) => {
  const { user } = member;
  return (
    <>
      {user.whatsapp_number && (
        <Link
          to={`https://wa.me/${user.whatsapp_number}`}
          target='_blank'
          className={cn(
            buttonVariants({ size: 'iconSm', variant: 'primaryOutline' }),
            'border-primary-200'
          )}
        >
          <WhatsappIcon />
        </Link>
      )}
      {generateIconBtns(user)?.map((btn, i) => (
        <DropdownMenu key={i}>
          <DropdownMenuTrigger
            className={cn(
              buttonVariants({ size: 'iconSm', variant: 'primaryOutline' }),
              'border-primary-200'
            )}
          >
            {btn.icon}
          </DropdownMenuTrigger>

          <DropdownMenuContent>
            {btn.dropdownItems.map((item) => (
              <DropdownMenuItem
                key={item.label}
                onClick={item.onClick}
                className='first:border-b first:font-medium first:border-pale-border first:rounded-none justify-center'
              >
                {item.icon}
                {item.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      ))}
    </>
  );
};
